import { render, staticRenderFns } from "./MarketplaceRatesTable.vue?vue&type=template&id=28c6df5a&scoped=true"
import script from "./MarketplaceRatesTable.vue?vue&type=script&lang=js"
export * from "./MarketplaceRatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6df5a",
  null
  
)

export default component.exports